import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
const positions = {
    bottom: 'align-bottom',
    center: 'align-middle',
    top: 'align-top',
};
export const RowLineTableData = (props) => {
    const { baseHorizontalSpace = 'px-4', children, className = '', colSpan = 1, position = 'center', } = props;
    return (_jsx("td", Object.assign({ className: clsx('border-none', 'first:pl-20 last:pr-20', baseHorizontalSpace, positions[position], className), colSpan: colSpan }, { children: children })));
};
